export default "__VITE_ASSET__bbab5dc3__"